<h2 mat-dialog-title name="confirmation-header">Transfer Request Confirmation</h2>
<mat-dialog-content class="mat-typography">
  <div *ngIf="!undo else undoTemplate">
    <div class="p-10" *ngIf="!confirmed">
      <p name="confirmation-content-p">
        Your new learning provider <b>{{data?.destinationOrganisationName}}</b> would like you to share your previous WEST learning with them, so they can copy <br>
        your records across from your previous learning provider, <b>{{data?.previousOrganisationName}}</b> <br>
        <br>
        This is so your new tutors can review the progress you've already made, and so that you can continue your learning <br>
        from where you left off.
        <br> 
        <br>
        To allow this, <b>please tick the box below</b> and press the "Yes" button. 
        <br><br>
        Please be aware that if you don't agree, you may need to begin your Essential Skills courses again with your new learning provider.
      </p>
      <mat-card id="agreeContainer">
        <mat-checkbox [formControl]="agreeCheckbox"><b class="agree-wrap">I have read the information above, and I agree that my previous WEST learning can be shared with my new learning provider.</b></mat-checkbox>
      </mat-card>
    
    </div>
  
    <div class="p-10" *ngIf="confirmed">
      <div name="confirmation-confirmed-progress">
        <b>You have agreed</b> to share your previous WEST learning with <b>your new learning provider {{data?.destinationOrganisationName}}.</b> <br>
        {{ (success) ? 'Click "Close" below to log out.' : 'Please wait while we process the transfer...' }}
        <br> 
        <br>
        <mat-label><b>Progress: </b></mat-label>
        <section class="example-section pt-10 pl-20">
          <p name="confirmation-confirmed-courses-copy" class="progress-copy-course" *ngFor="let course of data?.courses">
            <mat-icon *ngIf="success" class="done-copy">check_circle</mat-icon> 
            <mat-icon *ngIf="loader$ | async" class="loading-icon">cached</mat-icon> 
            <mat-icon *ngIf="success == false" class="icon-error">cancel</mat-icon>
            {{ (success) ? 'Finished copying' : 'Copying' }} {{ course }}
          </p>
          <p name="confirmation-confirmed-courses-copy" class="progress-copy-course">
            <mat-icon *ngIf="success" class="done-copy">check_circle</mat-icon> 
            <mat-icon *ngIf="loader$ | async" class="loading-icon">cached</mat-icon> 
            <mat-icon *ngIf="success == false" class="icon-error">cancel</mat-icon>
            {{ (success) ? 'Finished transfering' : 'Transfering' }} Learner account
          </p>
        </section>
        <br><br>
        <p name="note-logout" *ngIf="success == null"><b>NOTE</b>: You will be automatically logged out once the transfer is complete.</p>
        <p name="confirmation-confirmed-success" *ngIf="success">You will be automatically log out in {{ countdown }} seconds...</p>
        <p name="confirmation-confirmed-error" *ngIf="success == false" class="icon-error">Error occured while copying. Please try again and refresh the browser.</p>
      </div>  
    </div>
  </div>
  <ng-template #undoTemplate>
    <div class="p-10">
      <p name="confirmation-content-p">
        <b>You have NOT agreed</b> to transfer and your WEST learning with <b>{{data?.destinationOrganisationName}}</b>. <br>
        Please talk to your tutor or advisor about what to do next.
      </p>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div *ngIf="!undo else undoActions"> 
    <button  *ngIf="!confirmed"
    [disabled]="(loader$ | async)"
    [class.spinner]="loader$ | async" 
    name="confirmation-confirmed-no"
    mat-button (click)="undoTransfer()">No, I don't agree</button>
  <button  
    *ngIf="!confirmed"
    [disabled]="(loader$ | async)"
    [class.spinner]="loader$ | async" 
    name="confirmation-confirmed-agree"
    mat-button color="primary" (click)="agree()">Yes, I agree</button>
  <button  
    *ngIf="confirmed && success"
    [disabled]="(loader$ | async)"
    [class.spinner]="loader$ | async"
    name="confirmation-confirmed-close"
    mat-button color="primary" [mat-dialog-close]="true" (click)="logOut()" cdkFocusInitial>Close</button>
  </div>
  <ng-template #undoActions>
    <button  
      mat-button 
      color="primary" 
      name="confirmation-undo-close"
      [mat-dialog-close]="true" cdkFocusInitial>Close</button>
  </ng-template>
</mat-dialog-actions>
